import React from 'react';
const Button = (props) => {
    const { children, style, onClick, href, target } = props;
    return (React.createElement("a", { href: href, target: target, className: "button", style: style, onClick: onClick }, children));
};
export default Button;
